module.exports = __webpack_public_path__ + "static/img/netflix-benefit3.58d4758.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-benefit3.png
// module id = 1077
// module chunks = 1